import { useRef, useState } from "react";
import { mediaUrl } from "@/lib/api";
import { PlayOverlay } from "@/components/site/Badges";

export const VideoPlayer = ({ media, testId }) => {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  const ratio = media.width && media.height ? `${media.width} / ${media.height}` : "16 / 9";
  const start = () => {
    setStarted(true);
    ref.current?.play().catch(() => {});
  };
  return (
    <div className="relative mx-auto w-full overflow-hidden rounded-md bg-black" style={{ aspectRatio: ratio, maxHeight: "80vh" }} data-testid={testId}>
      <video
        ref={ref}
        src={mediaUrl(media.url)}
        poster={mediaUrl(media.poster_url)}
        aria-label={media.caption || "Project video"}
        controls
        playsInline
        preload="metadata"
        className="h-full w-full object-contain"
        onPlay={() => setStarted(true)}
        data-testid="project-video"
      />
      {!started && (
        <button className="absolute inset-0" onClick={start} aria-label={media.caption ? `Play video: ${media.caption}` : "Play project video"} data-testid="video-play-button">
          <PlayOverlay />
        </button>
      )}
    </div>
  );
};
